import { render, staticRenderFns } from "./DetailShareSetting.vue?vue&type=template&id=66bda61d&scoped=true&"
import script from "./DetailShareSetting.vue?vue&type=script&lang=js&"
export * from "./DetailShareSetting.vue?vue&type=script&lang=js&"
import style0 from "./DetailShareSetting.vue?vue&type=style&index=0&id=66bda61d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bda61d",
  null
  
)

export default component.exports